import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=b66ce410&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=b66ce410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ce410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66ce410')) {
      api.createRecord('b66ce410', component.options)
    } else {
      api.reload('b66ce410', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=b66ce410&scoped=true&", function () {
      api.rerender('b66ce410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YZ7ZmAHAfl96/JS/comp/CookieBox.vue"
export default component.exports